























import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
// import { SwCardView } from '@libs-uuif/shared/sw-card-view';
import UUIFComponents from '@/shared/uuifComponent';
// import { RootStoreState } from '@/store';
// import { State } from 'vuex-class';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwBannerCard } from '@/shared/banner-card-with-button';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'available-services';

@Component({
  components: {
    ...UUIFComponents,
    // SwCardView,
    MswAppTitle,
    SwBannerCard,
  },
})

export default class AvailableServices extends SwExtendedVue {
  cssPrefix = cssPrefix;
  availableServices: any = [];

  getAvailableServices() {
    this.$store.dispatch('AvailableServicesStoreModule/getAvailableServices')
    .then((res: any) => {
      this.$store.commit('stopLoading');
      res.content.applicationList.forEach((item:any) => {
        item.buttonLable = 'launch';
        this.availableServices.push(item);
      });
    });
  }
  goToServices(application:any) {
    let url = application.launchUrl;
    if (url.indexOf('~/') === 0) {
      url = `${location.origin}${url.replace('~/', '/')}`;
      if (url.indexOf('POSTIT') !== 0) {
        const sessionID = btoa(JSON.parse(this.$store.getters.getUserInfo).user.sessionId);
        url = `${url}?I=${sessionID}`;
      }
      window.open(
        url,
        '_top',
      );
    } else if (application.applicationName === 'Capture Security Center' && application.isGenerateAccessCode === 'YES') {
      const request = { tenant: '', tileName: 'ISMSWSAFEENABLED' };
      this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
        .then((resp: any) => {
          if (resp.content) {
            const { accessCode } = resp.content;
            const url = `${application.launchUrl}?code=${accessCode}`;
            window.open(
              url,
              '_top',
            );
          }
        })
        .catch((errorRespose: any) => {
          console.error(errorRespose);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    } else if (application.applicationName.toUpperCase() === 'SANDBOX' && application.isGenerateAccessCode === 'YES') {
      let userName = '';
      try {
        userName = JSON.parse((localStorage as any).getItem(currentUserKey)).userId;
      } catch (error) {
        console.error(error);
      }
      const request = { tenantId: '0', tileName: 'SANDBOX', mswUserName: userName };
      this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
        .then((resp: any) => {
          if (resp.content) {
            const { accessCode } = resp.content;
            const url = `${application.launchUrl}?code=${accessCode}`;
            window.open(
              url,
              '_top',
            );
          }
        })
        .catch((errorRespose: any) => {
          console.error(errorRespose);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    } else {
      window.open(
        application.launchUrl,
        '_blank',
      );
    }
  }
  mounted() {
    this.getAvailableServices();
  }
}
